import { render } from "./RationReminderModal.vue?vue&type=template&id=4829ff4b&scoped=true"
import script from "./RationReminderModal.vue?vue&type=script&lang=js"
export * from "./RationReminderModal.vue?vue&type=script&lang=js"

import "./RationReminderModal.vue?vue&type=style&index=0&id=4829ff4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4829ff4b"]])

export default __exports__